export const htmlRegexG = /<\/?(div|a|span|h1|h2|h3|h4|h5|h6|li|ul|ol|p|br|b|img|strong|i|em).*?>/gi;